import React, { useEffect, useRef } from "react";
const GoogleTranslate = ({ lang }) => {
  const previous = useRef();

  const googleTranslateElementInit = () => {
    // setCookie("googtrans", "/auto/en");
    window.google.translate.TranslateElement(
      {
        autoDisplay: false,
        includedLanguages: "en,es",
      },
      "google_translate_element"
    );
  };

  useEffect(() => {
    var addScript = document.createElement("script");
    addScript.setAttribute(
      "src",
      "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
    );

    document.body.appendChild(addScript);
    window.googleTranslateElementInit = googleTranslateElementInit;
  }, []);

  return <div id="google_translate_element"></div>;
};

export default GoogleTranslate;
// export default React.memo(GoogleTranslate);
